function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data,
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get("quantity-selector")) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector(".qty");
      this.step = this.input.getAttribute("step");
      this.changeEvent = new Event("change", {
        bubbles: true,
      });
      // Create buttons
      this.subtract = this.querySelector(".minus");
      this.add = this.querySelector(".plus");

      // Add functionality to buttons
      this.subtract.addEventListener("click", () =>
        this.change_quantity(-1 * this.step)
      );
      this.add.addEventListener("click", () =>
        this.change_quantity(1 * this.step)
      );
    }
    connectedCallback() {
      this.classList.add("buttons_added");
      this.validateQtyRules();
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute("min") > quantity + change) {
        return;
      }
    
      if (this.input.getAttribute("max")) {
        if (this.input.getAttribute("max") < quantity + change) {
          return;
        }
      }

      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, this.input.getAttribute("min"));

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);

      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle("disabled", value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle("disabled", value >= max);
      }
    }
  }
  customElements.define("quantity-selector", QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {
  constructor(self) {
    this.submenu = self.parentNode.querySelector(".sub-menu");
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener("click", (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains("active")) {
      submenu.classList.add("active");
    } else {
      submenu.classList.remove("active");
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll(".thb-arrow");
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get("product-card")) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector(".product-card-swatches");
      this.image = this.querySelector(
        ".product-featured-image-link .product-primary-image"
      );
      this.additional_images = this.querySelectorAll(
        ".product-secondary-image"
      );
      this.additional_images_nav = this.querySelectorAll(
        ".product-secondary-images-nav li"
      );
      this.quick_add = this.querySelector(
        ".product-card--add-to-cart-button-simple"
      );
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector(".product-featured-image");
      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains("hover")) {
            image.classList.remove("hover");
            if (nav.length) {
              nav[index].classList.remove("active");
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains("hover")) {
            selimg.classList.add("hover");
            if (nav.length) {
              nav[sel].classList.add("active");
            }
          }
        }
      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove("hover");
          if (nav.length) {
            nav[index].classList.remove("active");
          }
        });
      };
      if (image_container) {
        image_container.addEventListener("touchstart", mousemove, {
          passive: true,
        });
        image_container.addEventListener("touchmove", mousemove, {
          passive: true,
        });
        image_container.addEventListener("touchend", mouseleave, {
          passive: true,
        });
        image_container.addEventListener("mouseenter", mousemove, {
          passive: true,
        });
        image_container.addEventListener("mousemove", mousemove, {
          passive: true,
        });
        image_container.addEventListener("mouseleave", mouseleave, {
          passive: true,
        });
      }

      images.forEach(function (image) {
        window.addEventListener("load", (event) => {
          lazySizes.loader.unveil(image);
        });
      });
    }
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll(".product-card-swatch"),
        org_srcset = image ? image.dataset.srcset : "";

      swatch_list.forEach((swatch, index) => {
        window.addEventListener("load", (event) => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });

        swatch.addEventListener("mouseover", function () {
          [].forEach.call(swatch_list, function (el) {
            el.classList.remove("active");
          });
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute("srcset", swatch.dataset.srcset);
            } else {
              image.setAttribute("srcset", org_srcset);
            }
          }
          swatch.classList.add("active");
        });
        swatch.addEventListener("click", function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }
    enableQuickAdd() {
      this.quick_add.addEventListener("click", this.quickAdd.bind(this));
    }

    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add("loading");
      this.quick_add.setAttribute("aria-disabled", true);

      const config = {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/javascript",
        },
      };

      let formData = new FormData(this.form);

      formData.append("id", this.quick_add.dataset.productId);
      formData.append("quantity", 1);
      formData.append(
        "sections",
        this.getSectionsToRender().map((section) => section.section)
      );
      formData.append("sections_url", window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent("cart:item-added", {
            product: response.hasOwnProperty("items")
              ? response.items[0]
              : response,
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove("loading");
          this.quick_add.removeAttribute("aria-disabled");
        });

      return false;
    }
    getSectionsToRender() {
      return [
        {
          id: "Cart",
          section: "main-cart",
          selector: ".thb-cart-form",
        },
        {
          id: "Cart-Drawer",
          section: "cart-drawer",
          selector: ".cart-drawer",
        },
        {
          id: "cart-drawer-toggle",
          section: "cart-bubble",
          selector: ".thb-item-count",
        },
      ];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section) => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) ||
          document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
        if (typeof CartDrawer !== "undefined") {
          new CartDrawer();
        }
        if (typeof Cart !== "undefined") {
          new Cart().renderContents(parsedState);
        }
      });

      if (document.getElementById("Cart-Drawer")) {
        document.getElementById("Cart-Drawer").classList.add("active");
        document.body.classList.add("open-cart");
        document.body.classList.add("open-cc");
        if (
          document
            .getElementById("Cart-Drawer")
            .querySelector(".product-recommendations--full")
        ) {
          document
            .getElementById("Cart-Drawer")
            .querySelector(".product-recommendations--full")
            .classList.add("active");
        }
        dispatchCustomEvent("cart-drawer:open");
      }
    }
    getSectionInnerHTML(html, selector = ".shopify-section") {
      return new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define("product-card", ProductCard);
}
/**
 *  @class
 *  @function Header
 */
class Header {
  constructor() {
    const header = document.querySelector(".header-section"),
      header_main = document.getElementById("header"),
      menu = document.getElementById("mobile-menu"),
      toggle = document.querySelector(".mobile-toggle-wrapper"),
      a_bar = document.querySelector(
        ".shopify-section.shopify-section-group-header-group.announcement-bar-section"
      ),
      setHeaderOffset = this.setHeaderOffset,
      setAnnouncementHeight = this.setAnnouncementHeight,
      setHeaderHeight = this.setHeaderHeight;

    if (!header_main) {
      return;
    }
    document.addEventListener("keyup", (e) => {
      if (e.code) {
        if (e.code.toUpperCase() === "ESCAPE") {
          toggle.removeAttribute("open");
          toggle.classList.remove("active");
          header_main.classList.remove("header--mobile-open");
        }
      }
    });
    toggle.querySelector(".mobile-toggle").addEventListener("click", (e) => {
      setAnnouncementHeight(a_bar);
      if (toggle.classList.contains("active")) {
        e.preventDefault();
        document.body.classList.remove("overflow-hidden");
        toggle.classList.remove("active");
        header_main.classList.remove("header--mobile-open");
        this.closeAnimation(toggle);
      } else {
        document.body.classList.add("overflow-hidden");
        setTimeout(() => {
          toggle.classList.add("active");
          header_main.classList.add("header--mobile-open");
        });
      }
      window.dispatchEvent(new Event("resize.resize-select"));
    });

    // Mobile Menu offset
    window.addEventListener(
      "scroll",
      function () {
        setHeaderOffset(header);
        setHeaderHeight(header_main);
        // Sticky Header Class
        if (header_main.classList.contains("header-sticky--active")) {
          let offset =
            parseInt(header_main.getBoundingClientRect().top, 10) +
            document.documentElement.scrollTop;

          header_main.classList.toggle(
            "is-sticky",
            window.scrollY >= offset && window.scrollY > 0
          );
        }
      },
      {
        passive: true,
      }
    );
    window.dispatchEvent(new Event("scroll"));

    if (
      document.querySelector(
        ".shopify-section.shopify-section-group-header-group.announcement-bar-section"
      )
    ) {
      const a_bar = document.querySelector(
        ".shopify-section.shopify-section-group-header-group.announcement-bar-section"
      );

      window.addEventListener(
        "resize",
        function () {
          setAnnouncementHeight(a_bar);
        },
        {
          passive: true,
        }
      );
      window.dispatchEvent(new Event("resize"));

      const observer = new MutationObserver(function (mutations) {
        setAnnouncementHeight(a_bar);
      });

      const config = { attributes: true, childList: true, subtree: true };

      observer.observe(a_bar, config);
    }
    // Buttons.
    menu
      .querySelectorAll("summary")
      .forEach((summary) =>
        summary.addEventListener("click", this.onSummaryClick.bind(this))
      );
    menu
      .querySelectorAll("button")
      .forEach((button) =>
        button.addEventListener("click", this.onCloseButtonClick.bind(this))
      );

    this.onCartUpdate();
  }
  setAnnouncementHeight(a_bar) {
    a_bar.style.height = "auto";

    let h = a_bar.clientHeight - 1;
    document.documentElement.style.setProperty(
      "--announcement-height",
      h + "px"
    );
  }
  setHeaderOffset(header) {
    let h = header.getBoundingClientRect().top;
    document.documentElement.style.setProperty("--header-offset", h + "px");
  }
  setHeaderHeight(header) {
    let h = header.clientHeight;
    document.documentElement.style.setProperty("--header-height", h + "px");
  }
  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".link-container");
    const isOpen = detailsElement.hasAttribute("open");

    setTimeout(() => {
      detailsElement.classList.add("menu-opening");
      parentMenuElement && parentMenuElement.classList.add("submenu-open");
    }, 100);
  }
  onCloseButtonClick(event) {
    event.preventDefault();
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }
  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    this.closeAnimation(detailsElement);
  }
  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        detailsElement.querySelectorAll("details").forEach((details) => {
          details.removeAttribute("open");
          details.classList.remove("menu-opening");
          details.classList.remove("submenu-open");
        });
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
  onCartUpdate(event) {
    const cartDrawer = document.querySelector("#Cart-Drawer");
    const elkad_announcement_remaining = document.querySelector(
      ".elkad-announcement-remaining"
    );

    if (cartDrawer && elkad_announcement_remaining) {
      const observer = new MutationObserver(function (mutations) {
        fetch(window.Shopify.routes.root + "cart.js")
          .then((response) => response.json())
          .then((data) => {
            if (data.total_price == 0) {
              elkad_announcement_remaining.innerHTML =
                elkad_announcement_initial;
            } else if (data.total_price < elkad_announcement_target) {
              var updated_elkad_announcement_in_progress =
                document.createElement("span");
              updated_elkad_announcement_in_progress.innerHTML =
                elkad_announcement_in_progress;
              updated_elkad_announcement_in_progress.querySelector(
                ".elkad-announcement-price"
              ).innerHTML =
                ((elkad_announcement_target - data.total_price) / 100).toFixed(
                  2
                ) + elkad_announcement_currency;

              elkad_announcement_remaining.innerHTML = "";
              elkad_announcement_remaining.insertAdjacentElement(
                "beforeend",
                updated_elkad_announcement_in_progress
              );
            } else {
              elkad_announcement_remaining.innerHTML =
                elkad_announcement_unlocked;
            }
          });
      });

      const config = { childList: true, subtree: true };
      observer.observe(cartDrawer, config);
    }
  }
}
/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get("full-menu")) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.submenus = this.querySelectorAll(
        ".thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu"
      );

      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      window.addEventListener(
        "resize",
        debounce(function () {
          _this.resizeSubMenus();
        }, 100)
      );

      window.dispatchEvent(new Event("resize"));

      document.fonts.ready.then(function () {
        _this.resizeSubMenus();
      });
    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(
          ":scope >.menu-item-has-children>.sub-menu"
        );

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l =
              sub_submenu.parentElement.parentElement.getBoundingClientRect()
                .left +
              sub_submenu.parentElement.parentElement.clientWidth +
              10,
            total = w + l;
          if (total > document.body.clientWidth) {
            sub_submenu.parentElement.classList.add("left-submenu");
          } else if (
            sub_submenu.parentElement.classList.contains("left-submenu")
          ) {
            sub_submenu.parentElement.classList.remove("left-submenu");
          }
        });
      });
    }
  }
  customElements.define("full-menu", FullMenu);
}
/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get("side-panel-close")) {
  class PanelClose extends HTMLElement {
    constructor() {
      super();
      let cc = document.querySelector(".click-capture");

      // Add functionality to buttons
      this.addEventListener("click", (e) => this.close_panel(e));
      document.addEventListener("panel:close", (e) => {
        let panel = document.querySelectorAll(".side-panel.active");
        if (panel.length) {
          this.close_panel(e, panel[0]);
        }
      });
      cc.addEventListener("click", (e) => {
        let panel = document.querySelectorAll(".side-panel.active");
        if (panel) {
          this.close_panel(e, panel[0]);
        }
      });
    }

    close_panel(e, panel) {
      if (e) {
        e.preventDefault();
      }
      if (!panel) {
        panel = e?.target.closest(".side-panel");

        if (!panel) {
          return;
        }
      }
      if (panel.classList.contains("product-drawer")) {
        this.close_quick_view(panel);
      } else if (panel.classList.contains("cart-drawer")) {
        if (panel.querySelector(".product-recommendations--full")) {
          if (!document.body.classList.contains("open-quick-view")) {
            panel
              .querySelector(".product-recommendations--full")
              .classList.remove("active");
          }
        }
        if (window.innerWidth < 1069) {
          if (!document.body.classList.contains("open-quick-view")) {
            panel.classList.remove("active");
            document.body.classList.remove("open-cc");
            document.body.classList.remove("open-cart");
          } else {
            this.close_quick_view();
          }
        } else {
          if (panel.querySelector(".product-recommendations--full")) {
            if (!document.body.classList.contains("open-quick-view")) {
              setTimeout(() => {
                panel.classList.remove("active");
                document.body.classList.remove("open-cc");
                document.body.classList.remove("open-cart");
              }, 500);
            } else {
              this.close_quick_view();
            }
          } else {
            panel.classList.remove("active");
            document.body.classList.remove("open-cc");
            document.body.classList.remove("open-cart");
          }
        }
      } else {
        panel.classList.remove("active");
        document.body.classList.remove("open-cc");
      }
    }
    close_quick_view(panel) {
      panel = panel ? panel : document.getElementById("Product-Drawer");

      if (panel.querySelector(".product-quick-images--container")) {
        panel
          .querySelector(".product-quick-images--container")
          .classList.remove("active");
      }
      if (window.innerWidth < 1069) {
        panel.classList.remove("active");
        if (!document.body.classList.contains("open-cart")) {
          document.body.classList.remove("open-cc");
        }
        document.body.classList.remove("open-quick-view");
      } else {
        if (panel.querySelector(".product-quick-images--container")) {
          setTimeout(() => {
            panel.classList.remove("active");
            if (!document.body.classList.contains("open-cart")) {
              document.body.classList.remove("open-cc");
            }
            document.body.classList.remove("open-quick-view");
            panel.querySelector("#Product-Drawer-Content").innerHTML = "";
          }, 500);
        }
      }
    }
  }
  customElements.define("side-panel-close", PanelClose);

  document.addEventListener("keyup", (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === "ESCAPE") {
        dispatchCustomEvent("panel:close");
      }
    }
  });
}
/**
 *  @class
 *  @function CartDrawer
 */
class CartDrawer {
  constructor() {
    this.container = document.getElementById("Cart-Drawer");

    if (!this.container) {
      return;
    }
    let _this = this,
      button = document.getElementById("cart-drawer-toggle"),
      quantities = this.container.querySelectorAll(".quantity input");

    // Add functionality to buttons
    button.addEventListener("click", (e) => {
      e.preventDefault();
      document.body.classList.add("open-cc");
      document.body.classList.add("open-cart");
      this.container.classList.add("active");
      this.container.focus();
      setTimeout(() => {
        if (this.container.querySelector(".product-recommendations--full")) {
          this.container
            .querySelector(".product-recommendations--full")
            .classList.add("active");
        }
      });
      dispatchCustomEvent("cart-drawer:open");
    });

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.container.addEventListener(
      "change",
      this.debouncedOnChange.bind(this)
    );

    this.monitorShippingBar();
    this.notesToggle();
    this.disounctInputToggle();
    this.initremoveDiscountProductFromCartIfCartEmpty();
    this.removeProductEvent();
    this.updateFreeShipping();
    // Terms checkbox
    this.termsCheckbox();
  }
  onChange(event) {
    if (event.target.classList.contains("qty")) {
      this.updateQuantity(event.target.dataset.key, event.target.value);
    }
  }
  removeProductEvent() {
    let removes = this.container.querySelectorAll(".remove");

    removes.forEach((remove) => {
      remove.addEventListener("click", (event) => {
        this.updateQuantity(event.target.dataset.key, "0");

        event.preventDefault();
      });
    });
  }
  getSectionsToRender() {
    return [
      {
        id: "Cart-Drawer",
        section: "cart-drawer",
        selector: ".cart-drawer",
      },
      {
        id: "cart-drawer-toggle",
        section: "cart-bubble",
        selector: ".thb-item-count",
      },
    ];
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
  termsCheckbox() {
    let terms_checkbox = this.container.querySelector("#CartDrawerTerms"),
      checkout_button = this.container.querySelector(".button.checkout");

    if (!checkout_button) return;

    const checkout_form = checkout_button.closest("form");

    if (
      !checkout_form ||
      checkout_form.classList.contains("cart-drawer-checkout--initialized")
    ) {
      return;
    }

    checkout_form.addEventListener("click", (event) => {
      const submitter = event.target.closest(
        'button[type="submit"], button:not([type]), input[type="submit"], input[type="image"]'
      );

      if (submitter && checkout_form.contains(submitter)) {
        checkout_form._cartDrawerLastSubmitter = submitter;
      }
    });

    if (terms_checkbox) {
      const updateTermsValidity = () => {
        terms_checkbox.setCustomValidity(
          terms_checkbox.checked ? "" : theme.strings.requiresTerms
        );
      };

      updateTermsValidity();
      terms_checkbox.addEventListener("change", updateTermsValidity);
    }

    checkout_form.addEventListener("submit", async (event) => {
      if (checkout_form.dataset.cartDrawerCheckoutBypass === "true") {
        checkout_form.removeAttribute("data-cart-drawer-checkout-bypass");
        return;
      }

      const submitter =
        event.submitter || checkout_form._cartDrawerLastSubmitter || checkout_button;

      if (terms_checkbox && !terms_checkbox.checked) {
        terms_checkbox.reportValidity();
        terms_checkbox.focus();
        event.preventDefault();
        return;
      }

      if (checkout_form.classList.contains("cart-drawer-checkout--submitting")) {
        event.preventDefault();
        return;
      }

      event.preventDefault();
      checkout_form.classList.add("cart-drawer-checkout--submitting");
      checkout_button.disabled = true;

      const canCheckout = await this.canCheckoutWithCurrentCart();

      checkout_button.disabled = false;
      checkout_form.classList.remove("cart-drawer-checkout--submitting");

      if (!canCheckout) {
        alert("Please add at least one regular product before checkout.");
        this.updateCartDrawer();
        return;
      }

      this.resumeValidatedSubmit(checkout_form, submitter, checkout_button);
    });

    checkout_form.classList.add("cart-drawer-checkout--initialized");
  }
  resumeValidatedSubmit(checkout_form, submitter, fallback_submitter) {
    const effectiveSubmitter =
      submitter && checkout_form.contains(submitter) ? submitter : fallback_submitter;

    if (typeof checkout_form.requestSubmit === "function") {
      checkout_form.dataset.cartDrawerCheckoutBypass = "true";

      try {
        if (effectiveSubmitter) {
          checkout_form.requestSubmit(effectiveSubmitter);
        } else {
          checkout_form.requestSubmit();
        }
        return;
      } catch (error) {
        checkout_form.removeAttribute("data-cart-drawer-checkout-bypass");
      }
    }

    let hiddenInput;

    if (effectiveSubmitter && effectiveSubmitter.name) {
      hiddenInput = document.createElement("input");
      hiddenInput.type = "hidden";
      hiddenInput.name = effectiveSubmitter.name;
      hiddenInput.value = effectiveSubmitter.value || "";
      checkout_form.appendChild(hiddenInput);
    }

    checkout_form.submit();

    if (hiddenInput) {
      setTimeout(() => {
        hiddenInput.remove();
      }, 0);
    }
  }
  async canCheckoutWithCurrentCart() {
    try {
      const response = await fetch(`${theme.routes.cart_url}.js`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const cart = await response.json();
      const hasOnlyGiftedProducts =
        cart.items.length > 0 &&
        cart.items.every((item) => this.isGiftedCartItem(item));

      if (hasOnlyGiftedProducts) {
        this.removeDiscountProductFromCartIfCartEmpty(cart);
        return false;
      }

      return true;
    } catch (error) {
      console.error("Error validating cart for checkout:", error);
      return true;
    }
  }
  isGiftedCartItem(item) {
    return item && item.properties && item.properties._gifted == "true";
  }
  monitorShippingBar() {
    const shippingBar = document.getElementById("fsb_placeholder");
    const shippingBarCopyInCartDrawer = document.querySelector(
      ".side-panel-shipping_bar"
    );

    if (!shippingBar || !shippingBarCopyInCartDrawer) return;

    const observer = new MutationObserver((mutationList) => {
      mutationList.forEach((mutation) => {
        mutation.addedNodes.forEach((addedNode) => {
          if (addedNode.nodeType === 1 && addedNode.hasAttribute("onclick")) {
            shippingBarCopyInCartDrawer.innerText = addedNode.innerText;
            observer.disconnect();
          }
        });
      });
    });

    observer.observe(shippingBar, {
      childList: true, // Monitor direct child nodes
      subtree: true, // Monitor all descendants
      characterData: true, // Monitor changes to text nodes
    });
  }
  updateCartDrawer() {
    const formData = {
      sections: this.getSectionsToRender().map(
        (section) => section.section
      ),
      sections_url: window.location.pathname,
    };

    fetch(`${theme.routes.cart_update_url}.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/json`,
      },
      body: JSON.stringify(formData),
    })
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      const parsedState = JSON.parse(state);

      this.getSectionsToRender().forEach((section) => {
        const elementToReplace =
          document
            .getElementById(section.id)
            .querySelector(section.selector) ||
          document.getElementById(section.id);

        if (parsedState.sections) {
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        }
      });

      this.removeProductEvent();
      this.notesToggle();
      this.disounctInputToggle();
      this.initremoveDiscountProductFromCartIfCartEmpty();
      this.termsCheckbox();
      this.updateFreeShipping();
      this.monitorShippingBar();
    })
    .catch((error) => {
      console.error("Error updating cart drawer:", error);
    });
  }
  disounctInputToggle() {
    let discount_input_toggle = document.getElementById("mini-cart-discount-toggle");

    if (!discount_input_toggle || discount_input_toggle.classList.contains("mini-cart-discount-toggle--initialized")) {
      return;
    }

    discount_input_toggle.addEventListener("click", (event) => {
      discount_input_toggle.nextElementSibling.classList.add("active");
    });
    discount_input_toggle.nextElementSibling
      .querySelectorAll(".button, .mini-cart-discount-toggle__content-overlay")
      .forEach((el) => {
        el.addEventListener("click", async (event) => {
          discount_input_toggle.nextElementSibling.classList.remove("active");

          let discountProductData = document.getElementById("discount-product-data");
          const discountInput = document.getElementById("mini-cart__discount");
          const discountCode = discountInput ? discountInput.value.trim() : "";

          await this.saveDiscount(discountCode);

          if (!discountProductData || !discountCode) {
            this.updateCartDrawer();
            return;
          }

          discountProductData = JSON.parse(discountProductData.textContent);

          for (const product of discountProductData) {
            if (
              !product.code ||
              product.code.toLowerCase() != discountCode.toLowerCase()
            ) {
              continue;
            }

            await this.addDiscountProductToCart(product);
          }

          this.updateCartDrawer();
        });
      });
    discount_input_toggle.classList.add("mini-cart-discount-toggle--initialized");
  }
  async saveDiscount(discountCode = null) {
    const discountInput = document.getElementById("mini-cart__discount");
    const normalizedDiscount =
      typeof discountCode === "string"
        ? discountCode.trim()
        : discountInput
          ? discountInput.value.trim()
          : "";

    if (discountInput) {
      discountInput.value = normalizedDiscount;
    }

    const formData = {
      discount: normalizedDiscount,
    };

    try {
      const response = await fetch(`${theme.routes.cart_update_url}.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: `application/json`,
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Error saving discount:", error);
      return null;
    }
  }
  async addDiscountProductToCart(product) {
    const productIds = Array.isArray(product.product_variant_to_add_to_the_cart)
      ? product.product_variant_to_add_to_the_cart
      : [];

    if (productIds.length === 0) return false;

    try {
      const cartResponse = await fetch(`${theme.routes.cart_url}.js`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (!cartResponse.ok) {
        throw new Error(`HTTP ${cartResponse.status}`);
      }

      const cart = await cartResponse.json();
      const productsToAdd = [];

      // Check if the product is already in the cart
      for (let i = 0; i < productIds.length; i++) {
        const productId = String(productIds[i]);
        const productInCart = cart.items.find(
          (item) => String(item.id) === productId
        );

        if (!productInCart) {
          productsToAdd.push({
            id: productId,
            quantity: 1,
            properties: {
              _gifted: "true",
            }
          });
        }
      }

      if (productsToAdd.length === 0) return false;

      const formData = {
        items: productsToAdd
      };

      const addResponse = await fetch(`${theme.routes.cart_add_url}.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!addResponse.ok) {
        throw new Error(`HTTP ${addResponse.status}`);
      }

      await addResponse.json();
      return true;
    } catch (error) {
      console.error("Error adding discount product to cart:", error);
      return false;
    }
  }

  initremoveDiscountProductFromCartIfCartEmpty() {
    // document.addEventListener("line-item:change:end", (event) => {
    //   console.log(event);
    //   this.removeDiscountProductFromCartIfCartEmpty(event.cart);
    // });

    fetch(`${theme.routes.cart_url}.js`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
    .then((response) => response.json())
    .then((cart) => {
      this.removeDiscountProductFromCartIfCartEmpty(cart);
    });
  }

  removeDiscountProductFromCartIfCartEmpty(cart) {
    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return;

    const discountProducts = cart.items.filter((item) => this.isGiftedCartItem(item));
    if (discountProducts.length === 0) return;

    // Check if cart has only gifted products in it
    const hasOnlyGiftedProducts = cart.items.every((item) => this.isGiftedCartItem(item));
    if (hasOnlyGiftedProducts) {
      for (const product of discountProducts) {
        this.updateQuantity(product.key.replace(":", "-"), 0);
      }
    }
  }

  notesToggle() {
    let notes_toggle = document.getElementById("order-note-toggle");

    if (!notes_toggle) {
      return;
    }

    notes_toggle.addEventListener("click", (event) => {
      notes_toggle.nextElementSibling.classList.add("active");
    });
    notes_toggle.nextElementSibling
      .querySelectorAll(".button, .order-note-toggle__content-overlay")
      .forEach((el) => {
        el.addEventListener("click", (event) => {
          notes_toggle.nextElementSibling.classList.remove("active");
          this.saveNotes();
          this.addGiftMessageToCart();
        });
      });
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/json`,
      },
      body: JSON.stringify({
        note: document.getElementById("mini-cart__notes").value,
      }),
    });
  }

  addGiftMessageToCart() {
    const giftProductButton = document.getElementById("order-note-toggle");
    const productId = giftProductButton.getAttribute("data-gift-product-id");

    // Fetch the current cart contents
    fetch(`${theme.routes.cart_url}.js`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((cart) => {
        // Check if the product is already in the cart
        const productInCart = cart.items.find((item) => item.id == productId);

        if (productInCart) {
          console.log("Product is already in the cart.");
          return; // Exit early if product is already in the cart
        }

        // Continue if the product is not in the cart
        if (this.container.querySelector(".product-recommendations--full")) {
          this.container
            .querySelector(".product-recommendations--full")
            .classList.remove("active");
        }

        const formData = {
          items: [
            {
              id: productId,
              quantity: 1,
            },
          ],
          sections: this.getSectionsToRender().map(
            (section) => section.section
          ),
          sections_url: window.location.pathname,
        };

        fetch(`${theme.routes.cart_add_url}.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);

            this.getSectionsToRender().forEach((section) => {
              const elementToReplace =
                document
                  .getElementById(section.id)
                  .querySelector(section.selector) ||
                document.getElementById(section.id);

              if (parsedState.sections) {
                elementToReplace.innerHTML = this.getSectionInnerHTML(
                  parsedState.sections[section.section],
                  section.selector
                );
              }
            });

            this.removeProductEvent();
            this.notesToggle();
            this.disounctInputToggle();
            this.initremoveDiscountProductFromCartIfCartEmpty();
            this.termsCheckbox();
            this.updateFreeShipping();
            this.monitorShippingBar();
          });
      });
  }

  updateFreeShipping() {
    const free_shipping = this.container.querySelector(".free-shipping");

    if (free_shipping) {
      let amount_text = free_shipping.querySelector(
        ".free-shipping--text span"
      );
      let total = parseInt(free_shipping.dataset.cartTotal, 10);
      let minimum = Math.round(
        parseInt(free_shipping.dataset.minimum, 10) *
          (Shopify.currency.rate || 1)
      );
      let percentage = 1;

      if (total < minimum) {
        percentage = total / minimum;

        if (amount_text) {
          let remaining = minimum - total,
            format =
              window.theme.settings.money_with_currency_format || "${{amount}}";
          amount_text.innerHTML = formatMoney(remaining, format);
        }
      }

      free_shipping.style.setProperty("--percentage", percentage);
    }
  }

  updateQuantity(key, quantity) {
    this.container
      .querySelector(`#CartDrawerItem-${key}`)
      .classList.add("thb-loading");

    const body = JSON.stringify({
      id: key.replace("-", ":"),
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    dispatchCustomEvent("line-item:change:start", {
      quantity: quantity,
    });
    if (this.container.querySelector(".product-recommendations--full")) {
      this.container
        .querySelector(".product-recommendations--full")
        .classList.remove("active");
    }
    fetch(`${theme.routes.cart_change_url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/json`,
      },
      ...{
        body,
      },
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);

          if (parsedState.sections) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        });

        this.removeProductEvent();
        this.notesToggle();
        this.disounctInputToggle();
        this.initremoveDiscountProductFromCartIfCartEmpty();
        this.termsCheckbox();
        this.updateFreeShipping();
        this.monitorShippingBar();
        dispatchCustomEvent("line-item:change:end", {
          quantity: quantity,
          cart: parsedState,
        });

        if (this.container.querySelector(`#CartDrawerItem-${key}`)) {
          this.container
            .querySelector(`#CartDrawerItem-${key}`)
            .classList.remove("thb-loading");
        }
      });
  }
}

/**
 *  @class
 *  @function ModalDialog
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") {
        this.hide();
      }
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    this.querySelectorAll(".js-youtube").forEach((video) => {
      video.contentWindow.postMessage(
        '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
        "*"
      );
    });
    this.querySelectorAll(".js-vimeo").forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', "*");
    });
    this.querySelectorAll("video").forEach((video) => video.pause());
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

/**
 *  @class
 *  @function Localization
 */
class Localization {
  constructor() {
    let _this = this;
    // resize on initial load
    document
      .querySelectorAll(".thb-localization-forms")
      .forEach((localization) => {
        localization.addEventListener("change", (e) => {
          localization.querySelector("form").submit();
        });
      });
  }
}

/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    window.addEventListener("load", () => {
      document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);
    });

    // delegated listener on change
    document.body.addEventListener("change", (e) => {
      if (
        e.target.matches(".resize-select") &&
        e.target.offsetParent !== null
      ) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener("resize.resize-select", function () {
      document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement("option");
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement("select"),
      offset = 13;
    tempSelect.style.visibility = "hidden";
    tempSelect.style.position = "fixed";
    tempSelect.appendChild(tempOption);
    if (
      sel.classList.contains("thb-language-code") ||
      sel.classList.contains("thb-currency-code") ||
      sel.classList.contains("facet-filters__sort")
    ) {
      offset = 2;
    }
    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + offset}px`;
    }
    tempSelect.remove();
  }
}

if (typeof SelectWidth !== "undefined") {
  new SelectWidth();
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document
      .querySelectorAll(".thb-widget-title.collapsible")
      .forEach((button) => {
        button.addEventListener("click", (e) => {
          button.classList.toggle("active");
        });
      });
  }
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get("quick-view")) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector(".click-capture");
      this.drawer = document.getElementById("Product-Drawer");
      this.body = document.body;

      this.addEventListener("click", this.setupEventListener.bind(this));
    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace("//", "/");
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains("loading")) {
        return;
      }
      this.classList.add("loading");
      fetch(href, {
        method: "GET",
      })
        .then((response) => {
          this.classList.remove("loading");
          return response.text();
        })
        .then((text) => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector("#Product-Drawer-Content").innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);
        });
    }
    initNotifyForm() {
      if (
        typeof notifyPopin == "undefined" &&
        this.drawer.querySelector(".elkad-notify-when-out-of-stock-popin") &&
        !this.drawer
          .querySelector(".elkad-notify-when-out-of-stock-popin")
          .classList.contains("elkad-init")
      ) {
        const variantSelector = this.drawer.querySelector(
          ".elkad-notify-when-out-of-stock-popin__select"
        );
        const notifyPopin = this.drawer.querySelector(
          ".elkad-notify-when-out-of-stock-popin"
        );
        const submitNotify = this.drawer.querySelector(
          ".elkad-notify-when-out-of-stock-popin .elkad-submit"
        );
        const notifyTogglers = this.drawer.querySelectorAll(
          ".click-capture--elkad, .elkad-notify-when-out-of-stock-popin .elkad-popin__close, .elkad-notify-when-out-of-stock, .elkad-notify-when-out-of-stock__intro-text__button"
        );
        const notifyInput = this.drawer.querySelector(
          ".elkad-notify-when-out-of-stock-popin input[type='email']"
        );

        const toggleNotifyPopin = () => {
          variantSelector.value = notifyPopin.getAttribute("data-variant-id");
          notifyPopin.classList.toggle(
            "elkad-notify-when-out-of-stock-popin--hidden"
          );
          document.body.classList.toggle("open-cc--elkad");
        };

        const handleNotifyButton = () => {
          if (!notifyTogglers || !submitNotify) return;

          notifyTogglers.forEach((toggler) => {
            toggler.addEventListener("click", () => {
              toggleNotifyPopin();
            });
          });

          submitNotify.addEventListener("click", () => {
            BIS.create(
              notifyInput.value,
              variantSelector.value,
              notifyPopin.getAttribute("data-product-id")
            ).then(function (resp) {
              const response = resp.status == "OK" ? resp.message : resp.errors;

              if (resp.status == "OK") {
                this.drawer.querySelector(
                  ".elkad-notify-when-out-of-stock-popin .form-notification span"
                ).innerHTML = response;
                this.drawer
                  .querySelector(
                    ".elkad-notify-when-out-of-stock-popin .form-notification"
                  )
                  .classList.remove("error");
                this.drawer
                  .querySelector(
                    ".elkad-notify-when-out-of-stock-popin .form-notification"
                  )
                  .classList.add("success");
                submitNotify.scrollIntoView({ behavior: "smooth" });
              } else {
                this.drawer.querySelector(
                  ".elkad-notify-when-out-of-stock-popin .form-notification span"
                ).innerHTML = "";
                if (response.email) {
                  response.email.forEach((error) => {
                    this.drawer
                      .querySelector(
                        ".elkad-notify-when-out-of-stock-popin .form-notification span"
                      )
                      .insertAdjacentHTML("beforeend", `${error}<br>`);
                  });
                }
                if (response.base) {
                  response.base.forEach((error) => {
                    this.drawer
                      .querySelector(
                        ".elkad-notify-when-out-of-stock-popin .form-notification span"
                      )
                      .insertAdjacentHTML("beforeend", `${error}<br>`);
                  });
                }
                if (response.variant_no) {
                  response.variant_no.forEach((error) => {
                    this.drawer
                      .querySelector(
                        ".elkad-notify-when-out-of-stock-popin .form-notification span"
                      )
                      .insertAdjacentHTML("beforeend", `${error}<br>`);
                  });
                }
                this.drawer
                  .querySelector(
                    ".elkad-notify-when-out-of-stock-popin .form-notification"
                  )
                  .classList.remove("success");
                this.drawer
                  .querySelector(
                    ".elkad-notify-when-out-of-stock-popin .form-notification"
                  )
                  .classList.add("error");
              }
            });
          });

          notifyPopin.classList.add("elkad-init");
        };

        handleNotifyButton();
      }
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {
        this.drawer.querySelector("#Product-Drawer-Content").innerHTML =
          sectionInnerHTML;

        let js_files = this.drawer
          .querySelector("#Product-Drawer-Content")
          .querySelectorAll("script");

        if (js_files.length > 0) {
          var head = document.getElementsByTagName("head")[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement("script");
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        this.body.classList.add("open-cc");
        this.body.classList.add("open-quick-view");
        this.drawer.classList.add("active");

        this.drawer.querySelector(".side-panel-close").focus();

        setTimeout(() => {
          this.drawer
            .querySelector(".product-quick-images--container")
            .classList.add("active");
        });

        this.initNotifyForm();

        dispatchCustomEvent("quick-view:open", {
          productUrl: href,
          productHandle: productHandle,
        });
        addIdToRecentlyViewed(productHandle);
      }
    }
  }
  customElements.define("quick-view", QuickView);
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get("side-panel-content-tabs")) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll("button");
      this.panels = this.parentElement.querySelectorAll(
        ".side-panel-content--tab-panel"
      );
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() {}
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener("click", (e) => {
          this.toggleActiveClass(i);
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove("tab-active");
      });
      this.buttons[i].classList.add("tab-active");

      this.panels.forEach((panel) => {
        panel.classList.remove("tab-active");
      });
      this.panels[i].classList.add("tab-active");
    }
  }

  customElements.define("side-panel-content-tabs", SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get("collapsible-row")) {
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector("details");
      this.summary = this.querySelector("summary");
      this.content = this.querySelector(".collapsible__content");
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      if (
        document.body.classList.contains("animations-true") &&
        typeof gsap !== "undefined"
      ) {
        setTimeout(() => {
          this.prepareAnimations();
          this.querySelector("summary").addEventListener("click", (e) =>
            this.onClick(e)
          );
        }, 400);
      }
    }
    prepareAnimations() {
      let _this = this,
        summary_height = this.querySelector("summary").offsetHeight,
        content_height = this.querySelector(
          ".collapsible__content"
        ).offsetHeight,
        initial_height = summary_height,
        final_height = summary_height + content_height;

      this.tl = false;
      this.tl = gsap.timeline({
        reversed: !_this.details.open,
        paused: true,
        inherit: false,
        ease: "sine.inOut",
        onStart: function () {
          _this.details.open = true;
          _this.details.style.overflow = "hidden";
        },
        onReverseComplete: function () {
          _this.details.open = false;
          _this.details.style.overflow = "";
        },
      });

      this.tl.fromTo(
        _this.details,
        {
          height: function () {
            let h = Math.max(Math.max(initial_height, 0), 24);
            return h;
          },
          clearProps: "height",
        },
        {
          duration: 0.6,
          height: final_height,
          clearProps: "height",
        }
      );

      if (this.details.open) {
        this.tl.progress(1);
      }
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      e.preventDefault();
      if (this.tl.reversed()) {
        this.tl.timeScale(1).play();
      } else {
        this.tl.timeScale(3).reverse();
      }
    }
  }
  customElements.define("collapsible-row", CollapsibleRow);
}
/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {
  if (!handle) {
    let product = document.querySelector(".thb-product-detail");

    if (product) {
      handle = product.dataset.handle;

      if (!handle) {
        return;
      }
    }
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem("recently-viewed");
    if (recentIds && typeof recentIds !== undefined) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem(
      "recently-viewed",
      JSON.stringify(window.recentlyViewedIds)
    );
  }
}

document.addEventListener("DOMContentLoaded", () => {
  if (typeof Localization !== "undefined") {
    new Localization();
  }
  if (typeof CartDrawer !== "undefined") {
    new CartDrawer();
  }
  if (typeof Header !== "undefined") {
    new Header();
  }
  if (typeof FooterMenuToggle !== "undefined") {
    new FooterMenuToggle();
  }
});
